/**
 * defa.collections.RecipientGroups
 * A collection of RecipientGroup models.
 * @version 1.0.0
 */

import { RecipientGroup } from './model-recipientGroup';

export const RecipientGroups = Bb.Collection.extend( {
	model: RecipientGroup,
	comparator: model => model.name
} );

export default RecipientGroups;